import {
    STATISTICS_QUIZ_ROUTE,
    DOWNLOAD_QUIZ_STATISTICS_ROUTE
} from './constants';

import http from '../../../utils/httpService';

/**
 *
 * @param fromToDates
 * @param quizID
 * @returns {*}
 */
const requestStatisticsQuizzes = ( fromToDates, quizID ) => {
    let datesOptions = '';
    if ( fromToDates.from && fromToDates.to ) {
        datesOptions = `?from=${ fromToDates.from }&to=${ fromToDates.to }`;
    }

    const route = STATISTICS_QUIZ_ROUTE + `/${ quizID }` + datesOptions;

    return http.request( route, 'GET' );
};
/**
 *
 * @param fromToDates
 * @param quizID
 * @returns {*}
 */
const requestStatisticsFileQuizzes = ( fromToDates, quizID ) => {
    const route = DOWNLOAD_QUIZ_STATISTICS_ROUTE + `/${ quizID }` + '/statistics';

    return http.request( route, 'POST', fromToDates );
};

export {
    requestStatisticsQuizzes,
    requestStatisticsFileQuizzes
};